<template>
  <section class="[ max-w-5xl mx-auto ]">
    <h1 class="[ font-bold text-xl ]">Account details</h1>

    <div class="[ mt-4 max-w-xl ]">
      <CurrentUserEditForm />
    </div>
  </section>
</template>

<script setup lang="ts">
import CurrentUserEditForm from "@/components/auth/CurrentUserEditForm.vue";

definePage({
  meta: { title: "Account overview", icon: "user-circle" },
});
</script>
